var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "../utils/classNames";
import { HeaderNavigation } from "./Navigation/Navigation";
import { HeaderTitle } from "./Title/Title";
var headerPrefix = "header";
export var RawHeader = function (props) {
    var _a;
    var _b = props.usage, usage = _b === void 0 ? "tms" : _b;
    var headerProps = __assign(__assign({}, props), { usage: usage });
    var isCompact = !(props === null || props === void 0 ? void 0 : props.title) && !(props === null || props === void 0 ? void 0 : props.subtitle) && !(props === null || props === void 0 ? void 0 : props.reference);
    return (React.createElement("div", { className: classNames("".concat(headerPrefix, "--").concat(usage), isCompact ? "".concat(headerPrefix, "--compact") : "") },
        React.createElement(HeaderTitle, { title: props === null || props === void 0 ? void 0 : props.title, subtitle: props === null || props === void 0 ? void 0 : props.subtitle, reference: props === null || props === void 0 ? void 0 : props.reference, status: props === null || props === void 0 ? void 0 : props.status, width: (_a = props === null || props === void 0 ? void 0 : props.width) === null || _a === void 0 ? void 0 : _a.title }, (props === null || props === void 0 ? void 0 : props.children) && (props === null || props === void 0 ? void 0 : props.children)),
        ((props === null || props === void 0 ? void 0 : props.tabs) || (props === null || props === void 0 ? void 0 : props.back) || (props === null || props === void 0 ? void 0 : props.extra) || (props === null || props === void 0 ? void 0 : props.navigation)) && (React.createElement(HeaderNavigation, __assign({}, headerProps))),
        props.navigationExtra));
};
